import { Component, OnInit } from '@angular/core';
import { AzureAuthService } from 'src/service/azure-auth.service';

@Component({
  selector: 'public-embed',
  templateUrl: 'embedLayout.template.html',
  styleUrls: ["./embedLayout.component.css"]
})
export class EmbedLayoutComponent implements OnInit {

  constructor(public azureAuthService: AzureAuthService) {
  }

  ngOnInit() {
    //this.azureAuthService.onInit();
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
  }
}
